import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface Props {
  show: boolean;
  onHide: () => void;
  oemId: number | null;
  onSuccess: () => void;
}

export default function EditOEMModal({
  show,
  onHide,
  oemId,
  onSuccess,
}: Props) {
  const [supplier, setSupplier] = useState<any>({
    legal_name: "",
    email: "",
    phone: "",
    trade_name: "",
    rc_number: "",
    nif: "",
    nis: "",
    address: "",
    wilaya: "",
    website: "",
    workforce_total: 0,
    industrial_status: "active",
    maturity_score: 0,
  });

  // 🔹 LOAD DATA
  useEffect(() => {
    if (!oemId) return;

    fetch(`${backendUrl}/api/find/${oemId}`)
      .then((res) => res.json())
      .then((data) => setSupplier(data))
      .catch(() => toast.error("Error loading supplier"));
  }, [oemId]);

  // 🔹 INPUT CHANGE
  const handleChange = (e: any) => {
    setSupplier({
      ...supplier,
      [e.target.name]: e.target.value,
    });
  };

  // 🔹 UPDATE
  const handleSave = async () => {
    try {
      const res = await fetch(`${backendUrl}/api/update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_supplier: oemId,
          ...supplier,
        }),
      });

      if (!res.ok) throw new Error();

      toast.success("Supplier updated successfully");

      onHide();
      onSuccess();
    } catch {
      toast.error("Error updating supplier");
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Edit Supplier</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row>
            {/* LEFT COLUMN */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Legal Name</Form.Label>
                <Form.Control
                  name="legal_name"
                  value={supplier.legal_name}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  name="email"
                  value={supplier.email || ""}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  name="phone"
                  value={supplier.phone || ""}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Trade Name</Form.Label>
                <Form.Control
                  name="trade_name"
                  value={supplier.trade_name}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>RC</Form.Label>
                <Form.Control
                  name="rc_number"
                  value={supplier.rc_number}
                  onChange={handleChange}
                />
              </Form.Group>

              {/* ✅ STATUS UNDER RC */}
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  name="industrial_status"
                  value={supplier.industrial_status}
                  onChange={handleChange}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {/* RIGHT COLUMN */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>NIF</Form.Label>
                <Form.Control
                  name="nif"
                  value={supplier.nif}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>NIS</Form.Label>
                <Form.Control
                  name="nis"
                  value={supplier.nis}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  name="address"
                  value={supplier.address || ""}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Wilaya</Form.Label>
                <Form.Control
                  name="wilaya"
                  value={supplier.wilaya}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Website</Form.Label>
                <Form.Control
                  name="website"
                  value={supplier.website}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Workforce</Form.Label>
                <Form.Control
                  type="number"
                  name="workforce_total"
                  value={supplier.workforce_total}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>

        <Button variant="warning" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
